import React, { useEffect } from 'react';
import { useCollect } from 'hooks';

import Container from 'components/Misc/Container';
import { Input, Select } from 'components/Misc/Form';

const Search = ({ search, onChange }) => {
	// Store requested grades
	const [[grades], collect] = useCollect('grades');

	// Collect grades on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	return (
		<Container className="p-4 flex gap-4">
			<Select
				name="gradeId"
				placeholder="Klase"
				value={search.gradeId}
				onChange={onChange}
				options={grades?.map(grade => ({
					value: grade.id,
					name: grade.title
				}))}
			/>

			<Input
				name="title"
				placeholder="Nosaukums"
				value={search.title}
				onChange={onChange}
			/>
		</Container>
	);
};

export default Search;
